module.exports = __webpack_public_path__ + "img/disappointed_relieved.1bce1c54.png";